// removed by extract-text-webpack-plugin
module.exports = {"date_label":"date_label__1GVD7"};


//////////////////
// WEBPACK FOOTER
// ./components/card-date-label/style.scss
// module id = N6T2
// module chunks = 0 2